<template>
  <div class="ersoncal">
    <div class="myPersonage-background">
      <div class="ersoncal-mymall">
        <div class="ersoncal-mymall-persal">
          <img src="../../public/obraoag/malvter.png" alt="">
          <p>{{ersbacnt.NAME}} | {{ersbacnt.USERNAME}}</p>
        </div>
      </div>
      <div class="myPersonage-Shoprder">
        <div class="myPersonage-Shoprder-title">购物订单</div>
        <div class="myPersonage-Shoprder-claion">
          <router-link :to="{path:'Myorder',query: {myTobeid: '0'}}">
            <div class="myPersonage-Shoprder-claion-catory">
              <p class="myPersonage-Shoprder-claion-capaid">
                <img src="../../public/obraoag/alders.png" alt="">
              </p>
              <p class="myPersonage-Shoprder-claion-cattit">全部</p>
            </div>
          </router-link>
          <router-link :to="{path:'Myorder',query: {myTobeid: '1'}}">
            <div class="myPersonage-Shoprder-claion-catory">
              <p class="myPersonage-Shoprder-claion-cadeli">
                <img src="../../public/obraoag/agntpy.png" alt="">
              </p>
              <p class="myPersonage-Shoprder-claion-cattit">待付款</p>
            </div>
          </router-link>
          <router-link :to="{path:'Myorder',query: {myTobeid: '2'}}">
            <div class="myPersonage-Shoprder-claion-catory">
              <p class="myPersonage-Shoprder-claion-caeval">
                <img src="../../public/obraoag/conigt.png" alt="">
              </p>
              <p class="myPersonage-Shoprder-claion-cattit">待发货</p>
            </div>
          </router-link>
          <router-link :to="{path:'Myorder',query: {myTobeid: '3'}}">
            <div class="myPersonage-Shoprder-claion-catory">
              <p class="myPersonage-Shoprder-claion-casold">
                <img src="../../public/obraoag/gotsed.png" alt="">
              </p>
              <p class="myPersonage-Shoprder-claion-cattit">待收货</p>
            </div>
          </router-link>
          <router-link :to="{path:'Myorder',query: {myTobeid: '5'}}">
            <div class="myPersonage-Shoprder-claion-catory">
              <p class="myPersonage-Shoprder-claion-carder">
                <img src="../../public/obraoag/aftrle.png" alt="">
              </p>
              <p class="myPersonage-Shoprder-claion-cattit">退货/售后</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="myPersonage-Comols">
        <router-link :to="{path:'Seleress'}">
          <div class="ersoncal-advier">
            <p class="myPersonage-Shoprder-claion-catask">
              <img src="../../public/obraoag/revies.png" alt="">
            </p>
            <p class="myPersonage-Shoprder-claion-cattit">收货地址</p>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 底部导航 -->
    <botgaion snatus="3"></botgaion>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      loginID: '',
      maluerID: '',
      ersbacnt: ''
    }
  },
  created(){
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    this.$axios.post('wx/findByUserNameAndMessage',this.$qs.stringify({
      ID: this.loginID,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.ersbacnt = res.data.userX;
    })
    .catch(() => {
      console.log('获取失败');
    })
  },
  mounted(){

  },
  methods:{
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'shopmall'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/ersoncal.css";
</style>